import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OptionService} from "../option/option.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'headline',
    templateUrl: './output.headline.component.html',
    providers: []
})
export class HeadlineComponent implements OnInit {
    /**
     * the current step
     */
    @Input() step: string;

    /**
     * Event that is fired if the headline is hidden
     * @type {EventEmitter<any>}
     */
    @Output() toggleHeadline: EventEmitter<any> = new EventEmitter();

    /**
     * variable to configure if the component should be shown or not
     * @type {boolean}
     */
    show = true;

    /**
     * HOlds the type of the donation app that is called
     * @type {any}
     */
    type: string = null;

    /**
     * constructor
     * @param optionService
     * @param translationService
     */
    constructor(private optionService: OptionService, private translationService: TranslateService) {}

    /**
     * Called when the component is initialized
     */
    public ngOnInit(): void {
        this.type = this.optionService.getType();

        // do not show if we are on the startstep in the widget persion
        if (this.step === "start") {
            this.translationService.get(this.getHeadline()).subscribe(data => {
                // only show the headline if there is an non-empty text set for the headline
                this.show = !(data.trim().length === 0);
                this.toggleHeadline.emit(this.show);
            });
        }
        if (this.type === "page" && this.step === "start") {
            this.show = false;
        }
    }

    /**
     * Returns the textkey for the main headline
     * @returns {string}
     */
    getHeadline(): string {
        switch (this.step) {
            case "thankyou":
                return "headline.contact";
            case "end":
                return "headline.end";
            default:
                return "headline.default";
        }
    }
}
